var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.39074 9.97407C5.63482 9.73 6.03055 9.73 6.27462 9.97407L8.33268 12.0321L13.7241 6.64074C13.9682 6.39666 14.3639 6.39666 14.608 6.64074C14.852 6.88482 14.852 7.28055 14.608 7.52462L8.77462 13.358C8.53055 13.602 8.13482 13.602 7.89074 13.358L5.39074 10.858C5.14666 10.6139 5.14666 10.2182 5.39074 9.97407Z",
    fill: "#1F893F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 2.29102C5.74215 2.29102 2.29102 5.74215 2.29102 9.99935C2.29102 14.2565 5.74215 17.7077 9.99935 17.7077C14.2565 17.7077 17.7077 14.2565 17.7077 9.99935C17.7077 5.74215 14.2565 2.29102 9.99935 2.29102ZM1.04102 9.99935C1.04102 5.0518 5.0518 1.04102 9.99935 1.04102C14.9469 1.04102 18.9577 5.0518 18.9577 9.99935C18.9577 14.9469 14.9469 18.9577 9.99935 18.9577C5.0518 18.9577 1.04102 14.9469 1.04102 9.99935Z",
    fill: "#1F893F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.253bd17894a38e43be1075d815fde074.svg";
export { ForwardRef as ReactComponent };